import {
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  TabsContext,
  Search,
  Divider,
} from '@vibe/core';
import UploadTemplateButton from './UploadTemplateButton';
import UserTemplates from './UserTemplates';
import { useCallback, useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';
import { CLARITY_TAG_VALUE } from '@/constants/constants';
import { setClarityPageTag } from '@/utils/clarity.utils';

const DEBOUNCE_LIMIT = 300;

const TemplateGallery = ({ envelopeId }: { envelopeId: string }) => {
  const [searchValue, setSearchValue] = useState('');
  const [searchText] = useDebounce(searchValue, DEBOUNCE_LIMIT);

  useEffect(() => {
    setClarityPageTag(CLARITY_TAG_VALUE.PAGE_NAME.TEMPLATE_GALLERY);
  }, []);

  const handleSearchChange = useCallback((value: string) => {
    setSearchValue(value);
  }, []);

  return (
    <TabsContext
      activeTabId={0}
      className="flex flex-1 flex-col overflow-hidden px-8 py-8"
    >
      <div className="mb-2 flex items-center justify-between">
        <TabList onTabChange={() => {}}>
          <Tab>Templates Gallery</Tab>
          <Tab className="hidden">Pre-made Template</Tab>
        </TabList>
        <UploadTemplateButton envelopeId={envelopeId} />
      </div>

      <Divider className="mb-4" />
      <div className="pb-4">
        <Search
          placeholder="Search templates"
          onChange={(value: string) => setSearchValue(value)}
          autoFocus
        />
      </div>

      <TabPanels className="flex-1 overflow-auto">
        <TabPanel>
          <UserTemplates envelopeId={envelopeId} searchText={searchText} />
        </TabPanel>
        <TabPanel>
          <div></div>
        </TabPanel>
      </TabPanels>
    </TabsContext>
  );
};

export default TemplateGallery;
